import axios from 'axios'
import configuration from '@/configuration'
import VueCookies from 'vue-cookies'
import app from '@/main'

const mainApi = axios.create({
  baseURL: configuration.apiUrl
})

mainApi.interceptors.request.use((config) => {
  const token = app.$store.getters.userToken

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export const getUserData = async () => {
  try {
    // Use production API for user data
    const productionApi = axios.create({
      baseURL: 'https://app.api.trainerday.com'
    })
    
    // Get token from cookies directly to avoid store initialization issues
    const token = VueCookies.get('token')
    const headers = token ? { Authorization: `Bearer ${token}` } : {}
    
    const resp = await productionApi.get('/api/users/get_me', { headers })
    return resp.data
  } catch (error) {
    // Handle 401 Unauthorized gracefully
    if (error.response && error.response.status === 401) {
      // Clear invalid token from cookies
      VueCookies.remove('token')
      // Return null to indicate user is not authenticated
      return null
    }
    
    // Re-throw other errors
    throw error
  }
}

export const getUserVideoLists = async () => {
  const resp = await mainApi.get('/api/broadcast/video-lists')
  return resp.data
}

export const addLinkToVideoList = async (linkToVideo) => {
  const resp = await mainApi.post('/api/broadcast/video-lists/add-link', { linkToVideo })
  return resp.data
}

export const deleteLinkFromVideoList = async (linkToVideo) => {
  const resp = await mainApi.delete('/api/broadcast/video-lists/delete-link', { data: { linkToVideo } })
  return resp.data
}

export const getRoutes = async (linkToVideo) => {
  const resp = await mainApi.get('/api/user-broadcast-routes')
  return resp.data
}

export const saveRoute = async (body) => {
  const resp = await mainApi.post('/api/user-broadcast-routes/create', body)
  return resp.data
}

export const updateRoute = async (body) => {
  const resp = await mainApi.patch('/api/user-broadcast-routes/update', body)
  return resp.data
}

export const deleteRoute = async (_id) => {
  const resp = await mainApi.delete('/api/user-broadcast-routes/delete', { data: { _id } })
  return resp.data
}
